import PF_WelcomePage from '../../pathfinder/components/welcome/WelcomePage';
import PF_ChatBotPage from '../../pathfinder/components/chatbot/ChatBotPage';
import PF_AssessmentPage from '../../pathfinder/components/chatbot/AssessmentPage';
import PF_ChatBotEvaluationPage from '../../pathfinder/components/chatbot/ChatBotEvaluationPage';
import PF_HomePage from '../components/standard-forms/home/HomePage';
import PF_StartQuestionsPage from '../components/standard-forms/start-questions/StartQuestionsPage';
import PF_GeneralQuestionsPage from '../components/standard-forms/general-questions/GeneralQuestionsPage';
import PF_MainSymptomPage from '../components/standard-forms/main-symptom/MainSymptomPage';
import PF_RelatedSymptomsPage from '../components/standard-forms/related-symptoms/RelatedSymptomsPage';
import PF_SymptomQuestions from '../components/standard-forms/symptom-questions/SymptomsQuestionsPage';
import PF_SharedQuestions from '../components/standard-forms/shared-questions/SharedQuestionsPage';
import PF_EvaluationPage from '../components/standard-forms/evaluation/EvaluationPage';
import PF_ChatbotAssessmentSharePage from '../components/chatbot/ChatbotAssessmentSharePage';


let pathfinderRoutesPrefix = "/pathfinder";


// ======================================================================
// PATHFINDER routes.
// ======================================================================

let pathfinderRoutes = [
    {
        path: pathfinderRoutesPrefix + '/welcome',
        name: 'PF_WelcomePage',
        component: PF_WelcomePage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: pathfinderRoutesPrefix + '/home',
        name: 'PF_HomePage',
        component: PF_HomePage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: pathfinderRoutesPrefix + '/chatbot',
        name: 'PF_ChatBotPage',
        component: PF_ChatBotPage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: pathfinderRoutesPrefix + '/assessment',
        name: 'PF_AssessmentPage',
        component: PF_AssessmentPage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: pathfinderRoutesPrefix + '/chatbot-scoring',
        name: 'PF_ChatBotEvaluationPage',
        component: PF_ChatBotEvaluationPage,
        meta: {
            forAuth: true,
        }
    },
    {
        path: pathfinderRoutesPrefix + '/start-questions',
        name: 'PF_StartQuestionsPage',
        component: PF_StartQuestionsPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '/general-questions',
        name: 'PF_GeneralQuestionsPage',
        component: PF_GeneralQuestionsPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '/main-symptom',
        name: 'PF_MainSymptomPage',
        component: PF_MainSymptomPage,
        meta: {
            forAuth: true
        }
    },
  /*  {
        path: pathfinderRoutesPrefix + '/main-symptom-questions',
        name: 'PF_MainSymptomQuestionsPage',
        component: PF_MainSymptomQuestionsPage,
        meta: {
            forAuth: true
        }
    },*/
    {
        path: pathfinderRoutesPrefix + '/related-symptoms',
        name: 'PF_RelatedSymptomsPage',
        component: PF_RelatedSymptomsPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '/symptom-questions',
        name: 'PF_SymptomQuestions',
        component: PF_SymptomQuestions,
        meta: {
            forAuth: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '/shared-questions',
        name: 'PF_SharedQuestions',
        component: PF_SharedQuestions,
        meta: {
            forAuth: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '/scoring',
        name: 'PF_EvaluationPage',
        component: PF_EvaluationPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '/chatbot-assessment-share',
        name: 'PF_ChatbotAssessmentSharePage',
        component: PF_ChatbotAssessmentSharePage,
        meta: {
            forAuth: true
        }
    }
  /*  {
        path: pathfinderRoutesPrefix + '/related-symptom-questions',
        name: 'PF_RelatedSymptomQuestionsPage',
        component: PF_RelatedSymptomQuestionsPage,
        meta: {
            forAuth: true
        }
    },

    {
        path: pathfinderRoutesPrefix + '/evaluation',
        name: 'PF_EvaluationPage',
        component: PF_EvaluationPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '/scoring',
        name: 'PF_ScoringPage',
        component: PF_ScoringPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '/summary',
        name: 'PF_SummaryPage',
        component: PF_SummaryPage,
        meta: {
            forAuth: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '*',
        redirect: '/',
        name: 'PF_UndefinedPages',
        component: LoginPage,
        meta: {
            forVisitors: true
        }
    },
    {
        path: pathfinderRoutesPrefix + '/user-account',
        name: 'PF_UserAccountPage',
        component: PF_UserAccountPage,
        meta: {
            forAuth: true,
        }
    }*/
];


export default pathfinderRoutes;



// WEBPACK FOOTER //
// ./src/pathfinder/router/routes-pathfinder.js